import { styled } from "@mui/material";

export const EmailSentLabel = styled("span")(() => ({
  color: "#308CDB",
  fontWeight: 400,
}));

export const EmailNotSentLabel = styled("span")(() => ({
  color: "#CF4842",
  fontWeight: 400,
}));

export const SeaTypeLabel = styled("span")(() => ({
  color: "#308CDB",
  fontWeight: 500,
}));

export const AirTypeLabel = styled("span")(() => ({
  color: "#38CFC4",
  fontWeight: 500,
}));
